/* Moonrise — Link Prefetcher
 * Hover/touchstart prefetch for instant internal navigation.
 * Zero dependencies. Progressive enhancement — degrades cleanly.
 *
 * How it works:
 *   1. On mouseover (80 ms debounce): inject <link rel="prefetch"> for internal links.
 *   2. On touchstart: prefetch immediately (before tap registers as click).
 *   3. Cached requests are served from browser cache → near-instant next page.
 */

(function () {
  'use strict';

  /* Feature detection */
  var linkEl = document.createElement('link');
  if (!linkEl.relList || !linkEl.relList.supports('prefetch')) return;

  var seen = new Set();
  var timer = 0;
  var DELAY = 80;

  function isInternal(href) {
    if (!href || /^(mailto|tel|javascript):/i.test(href) || href.charAt(0) === '#') return false;
    try {
      return new URL(href, location.href).hostname === location.hostname;
    } catch (_) { return false; }
  }

  function eligible(el) {
    if (!el || el.tagName !== 'A') return false;
    var href = el.getAttribute('href');
    if (!isInternal(href)) return false;
    if (el.hasAttribute('download') || el.getAttribute('target') === '_blank') return false;
    if (el.rel === 'nofollow' || el.dataset.noPrefetch !== undefined) return false;
    return !seen.has(href);
  }

  function prefetch(el) {
    var href = el.getAttribute('href');
    if (seen.has(href)) return;
    seen.add(href);
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  }

  document.addEventListener('mouseover', function (e) {
    clearTimeout(timer);
    var el = e.target.closest('a[href]');
    if (!eligible(el)) return;
    timer = setTimeout(function () { prefetch(el); }, DELAY);
  }, { passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(timer);
  }, { passive: true });

  document.addEventListener('touchstart', function (e) {
    var el = e.target.closest('a[href]');
    if (eligible(el)) prefetch(el);
  }, { passive: true });

})();
